import React, { useState, useEffect } from "react";

import Button from "components/Button";
import SvgShare from "assets/svgs/share.svg";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  RedditShareButton,
  RedditIcon,
  EmailShareButton,
  EmailIcon,
} from 'react-share'

export default function Share({ className, shareContent }) {
  const [open, setOpen] = useState(false);

  const [hasMounted, setHasMounted] = useState(false);
  
  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  const { shareUrl = "https://uncovered.com/cases", quote, hashtag } = shareContent;

  return (
    <div className={`relative ${className}`}>
      <Button
        emphasis="primaryHollow"
        height="32"
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        isDiv={true}
      >
        <SvgShare className="mr-2" width="14" /> Share
        <div
          className={`custom-popup absolute bottom-full bg-white duration-300 mt-4 opacity-0 pb-1 pt-2 pointer-events-none transform transition-opacity z-10 ${
            open ? "opacity-100 pointer-events-auto" : ""
          }`}
          style={{
            borderBottom: "12px solid #000000",
            left: "calc(50% - 75px)",
            minHeight: "47px",
            width: "150px",
          }}
        >
          <FacebookShareButton
            url={shareUrl}
            quote={quote}
            hashtag={hashtag}
          >
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton
            url={shareUrl}
            title={quote}
            hashtags={[hashtag]}
          >
            <TwitterIcon size={32} round />
          </TwitterShareButton>
          <RedditShareButton
            url={shareUrl}
            title={quote}
            windowWidth={660}
            windowHeight={460}
          >
            <RedditIcon size={32} round />
          </RedditShareButton>
          <EmailShareButton
            url={shareUrl}
            subject={quote}
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
          
        </div>
      </Button>
    </div>
  );
}
